exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-FileUpload-noAttachmentsContainer{vertical-align:middle}.src-components-shared-FileUpload-maxAttachmentsContainer{vertical-align:middle;color:#929292}.src-components-shared-FileUpload-attachmentContainer{border-top:1px solid #ced4da;border-left:1px solid #ced4da;border-right:1px solid #ced4da}.src-components-shared-FileUpload-attachmentRow{border-bottom:1px solid #ced4da}.src-components-shared-FileUpload-fileIcon{font-size:25px !important}.src-components-shared-FileUpload-deleteIcon{cursor:pointer}.src-components-shared-FileUpload-inactive{color:#929292}.src-components-shared-FileUpload-uploadWrapper{border:2px solid #b3b3b3 !important;border-radius:0 !important}", ""]);

// exports
exports.locals = {
	"noAttachmentsContainer": "src-components-shared-FileUpload-noAttachmentsContainer",
	"maxAttachmentsContainer": "src-components-shared-FileUpload-maxAttachmentsContainer",
	"attachmentContainer": "src-components-shared-FileUpload-attachmentContainer",
	"attachmentRow": "src-components-shared-FileUpload-attachmentRow",
	"fileIcon": "src-components-shared-FileUpload-fileIcon",
	"deleteIcon": "src-components-shared-FileUpload-deleteIcon",
	"inactive": "src-components-shared-FileUpload-inactive",
	"uploadWrapper": "src-components-shared-FileUpload-uploadWrapper"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/FileUpload/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/FileUpload/styles.scss
// module chunks = 1